// REACT
import React, { useContext } from 'react'

// ESTILOS
import Styles from './Services.module.css'

// CONTEXTO
import MainContext from 'Context/MainContext'

const ServicesContact: React.FC = () => {
	// CONTEXTO
	const { contact } = useContext(MainContext).lang.services

	return (
		<ul className={Styles.contactList}>
			<li className={Styles.contactListItem}>
				<a
					target='_blank'
					rel='noopener noreferrer'
					className={Styles.contactListLink}
					href={`https://api.whatsapp.com/send?phone=${contact.phone_1
						.replace('-', '')
						.replace(' ', '')
						.replace(
							'+',
							''
						)}&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20reservar%20una%20habitaci%C3%B3n%20en%20Villa%20de%20Don%20Andr%C3%A9s.`}
					title={contact.phone_1}>
					<i className='lni lni-whatsapp' /> {`${contact.phone_1} / `}
				</a>
				<a
					target='_blank'
					rel='noopener noreferrer'
					className={Styles.contactListLink}
					href={`https://api.whatsapp.com/send?phone=${contact.phone_2
						.replace('-', '')
						.replace(' ', '')
						.replace(
							'+',
							''
						)}&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20reservar%20una%20habitaci%C3%B3n%20en%20Villa%20de%20Don%20Andr%C3%A9s.`}
					title={contact.phone_2}>
					{contact.phone_2}
				</a>
			</li>
			<li className={Styles.contactListItem}>
				<a
					target='_blank'
					rel='noopener noreferrer'
					className={Styles.contactListLink}
					href='https://www.messenger.com/t/villadonandres'
					title='Messenger'>
					<i className='lni lni-facebook-messenger' /> {contact.messenger}
				</a>
			</li>
			<li className={Styles.contactListItem}>
				<a
					target='_blank'
					rel='noopener noreferrer'
					className={Styles.contactListLink}
					href={`mailto:${contact.email}`}
					title={contact.email}>
					<i className='lni lni-envelope' /> {contact.email}
				</a>
			</li>
		</ul>
	)
}

export default ServicesContact
